var produitsPromo = {};

function verifierPromo(handle) {
  return fetch("/collections/soldes/products.json?limit=250")
    .then(function(res) { return res.json(); })
    .then(function(data) {
      data.products.forEach(function(p) {
        produitsPromo[p.handle] = true;
      });
    });
}

function mettreAJourBarre(panier) {
  var OBJECTIF = 100;
  var montant = 0;

  panier.items.forEach(function(article) {
    var handle = article.handle ? article.handle.toLowerCase() : "";
    var estPromo = produitsPromo[handle] === true;

    if (!estPromo) {
      montant += (article.price / 100) * article.quantity;
    }
  });

  var restant = Math.max(0, OBJECTIF - montant);
  var progression = Math.min(100, (montant / OBJECTIF) * 100);

  var message = restant > 0
    ? "Plus que <strong>" + restant.toFixed(2).replace(".", ",") + "€</strong> pour débloquer ton cadeau surprise 🎁"
    : "🎁 Félicitations ! Tu as débloqué ton cadeau surprise !";

  document.querySelectorAll(".barre-cadeau-message").forEach(function(el) {
    el.innerHTML = message;
  });

  document.querySelectorAll(".barre-cadeau-progression").forEach(function(el) {
    el.style.width = progression + "%";
    if (restant === 0) {
      el.style.background = "#4CAF50";
    } else {
      el.style.background = "linear-gradient(90deg, #6c63ff, #e53935)";
    }
  });

  document.querySelectorAll(".barre-cadeau-panier").forEach(function(el) {
    if (restant === 0) {
      el.style.background = "#f0fff0";
      el.style.borderColor = "#a5d6a7";
    } else {
      el.style.background = "#fff9f0";
      el.style.borderColor = "#ffe0b2";
    }
  });

  var cartDrawer = document.querySelector(".cart-drawer__dialog") ||
                   document.querySelector("cart-drawer-component");

  if (cartDrawer) {
    var barreExistante = cartDrawer.querySelector(".barre-cadeau-panier");
    if (!barreExistante) {
      var barre = document.createElement("div");
      barre.classList.add("barre-cadeau-panier");
      barre.innerHTML = '<p class="barre-cadeau-message">' + message + '</p>' +
        '<div class="barre-cadeau-container">' +
          '<div class="barre-cadeau-progression" style="width:' + progression + '%; background:' + (restant === 0 ? "#4CAF50" : "linear-gradient(90deg, #6c63ff, #e53935)") + '"></div>' +
        '</div>';

      var checkout = cartDrawer.querySelector("[name='checkout']") ||
                     cartDrawer.querySelector(".cart__checkout-button") ||
                     cartDrawer.querySelector("button[type='submit']");
      if (checkout) {
        checkout.parentNode.insertBefore(barre, checkout);
      }
    }
  }
}

function chargerPanier() {
  fetch("/cart.js")
    .then(function(res) { return res.json(); })
    .then(function(panier) {
      mettreAJourBarre(panier);
    });
}

document.addEventListener("DOMContentLoaded", function() {
  verifierPromo().then(function() {
    chargerPanier();
  });

  var originalFetch = window.fetch;
  window.fetch = function() {
    var args = Array.prototype.slice.call(arguments);
    var url = args[0];
    return originalFetch.apply(this, args).then(function(response) {
      if (typeof url === "string" && (url.includes("/cart/add") || url.includes("/cart/change") || url.includes("/cart/update"))) {
        setTimeout(chargerPanier, 500);
      }
      return response;
    });
  };

  var observer = new MutationObserver(function() {
    chargerPanier();
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

if (window.location.pathname === "/cart") {
  var btnPayer = document.querySelector("[name='checkout']") ||
                 document.querySelector(".cart__checkout-button") ||
                 document.querySelector("button[type='submit']");

  if (btnPayer) {
    var barrePagePanier = document.createElement("div");
    barrePagePanier.classList.add("barre-cadeau-panier");
    barrePagePanier.innerHTML =
      '<p class="barre-cadeau-message">Chargement...</p>' +
      '<div class="barre-cadeau-container">' +
        '<div class="barre-cadeau-progression"></div>' +
      '</div>';
    btnPayer.parentNode.insertBefore(barrePagePanier, btnPayer.nextSibling);
  }
}